import {
  TEXT,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import {
  OPTIONAL_TEXT_FIELDS,
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const Text2: Translator = sequence => {
  const optional = optionalFieldsInEditor(OPTIONAL_TEXT_FIELDS);
  const LayoutListItems: LayoutListDefinition[] = [];

  const root = translate(sequence, item => {
    if (item.__typename === 'Text') {
      LayoutListItems.push({
        id: `${item.id}_list`,
        type: LAYOUT_LIST,
        values: {
          align: 'left',
          padded: true
        },
        items: [
          {
            type: TEXT,
            id: `${item.id}_title`,
            items: [],
            values: {
              ...optionalFieldValues(optional, 'title'),
              value: item.title as string,
              variant: 'heading1'
            }
          },
          {
            type: TEXT,
            id: `${item.id}_body`,
            items: [],
            values: {
              ...optionalFieldValues(optional, 'body'),
              value: item.body,
              variant: 'text'
            }
          }
        ]
      });
    }

    return null;
  });

  root.items.push({
    type: LAYOUT_COLUMNS,
    id: '1',
    values: {},
    items: LayoutListItems
  });

  return root;
};
